import {Box, Button, Checkbox, Dialog, DialogContent, DialogContentText, DialogTitle, FormControl, MenuItem, Select, TextField, Typography} from "@mui/material";
import React, {useEffect, useState} from "react";
// import categoryMappings from "app/pages/Docgen/constants/category_mappings";

const UploadFormModal = props => {

    const [checked, setChecked] = useState({});
    const [selectedDocument,setSelectedDocument] = useState("");
    const { uploadModalOpen, setUploadModalOpen,formList,uploadedFiles,setUploadedFiles , formMappings} = props;
    const [newDocumentClick,setNewDocumentClick] = useState(false);
    const [selectedCategory,setSelectedCategory] = useState("");
    const [selectedDescription,setSelectedDescription] =useState("");
    const [newDocumentName,setNewDocumentName] = useState("");

    const docketNumber = formList[0]?.generated_form_matter?.host_file_number || formList[0]?.host_file_number;

    const handleClose = () => {
        setUploadModalOpen(false);
    };

    const handleClick = () => {
 
    }

    const handleCheck = e => {
        setChecked({ ...checked, [e.target.id]: e.target.checked });
    };

    const handleDeleteForm = (clickedFileName) =>{
        setUploadedFiles(uploadedFiles.filter((p) => p.file.name!==clickedFileName))
    }

    const handleNewDocumentClick = (e) => {
        setNewDocumentClick(!newDocumentClick);
        setSelectedDocument("")
    }

    const handleDocumentSelect = (e) =>{
        setNewDocumentClick(false);
        setSelectedCategory("");
        setSelectedDescription("");
        setNewDocumentName("");
        setSelectedDocument(e.target.value);


    }

    const handleSelectCategory = (e) =>{
        setSelectedDocument("");
        setSelectedDescription("")
        setSelectedCategory(e.target.value)
    }

    const handleCancel = () =>{
        setSelectedDocument("");
        setSelectedDescription("");
        setSelectedCategory("");
        setNewDocumentName("");
        setNewDocumentClick(false);
    }

    const handleSave = () =>{

        const selectedIndex = uploadedFiles.findIndex((p) => checked[p.file.name] === true);
        if (selectedIndex !== -1) {
            const newUploadedFiles = [...uploadedFiles];

            let updatedName;
            if (selectedDocument!==""){
                updatedName = `${docketNumber}_${selectedDocument}`;
                newUploadedFiles[selectedIndex].modifiedName = updatedName;
            }
            
        if (newDocumentClick && newDocumentName!="") {
            newUploadedFiles[selectedIndex].category = selectedCategory;
            newUploadedFiles[selectedIndex].description = selectedDescription;
            newUploadedFiles[selectedIndex].modifiedName = `${docketNumber}_${newDocumentName}`;
        }
            

            setUploadedFiles(newUploadedFiles);
        }
      
    }

    useEffect(()=>{
        setSelectedDocument("");
        setNewDocumentClick(false);
        setSelectedCategory("");
        setSelectedDescription("");
        setNewDocumentName("");
    },[checked])

    useEffect(()=>{
        if (uploadedFiles.length ===0){
            setUploadModalOpen(false);
        }
    },[uploadedFiles])
    

    return (
     <div>
            <Dialog open={uploadModalOpen} onClose={handleClose} aria-labelledby="form-dialog-title" fullWidth maxWidth="lg">
            <DialogTitle id="form-dialog-title">
              <Typography align="center" sx={{ fontWeight: 'bold' }}>{`Docket Number: ${docketNumber}`}</Typography>
            </DialogTitle>
                <DialogContent>
                    <DialogContentText>New Uploaded Files:</DialogContentText>
                    <br></br>

                <Box sx={{ display: 'flex',flexDirection: 'row', alignItems: 'center'}}>
                    <Box sx={{ display: 'flex',flexDirection: 'column',width:"40%"}}>
                        {uploadedFiles.filter(Boolean).map((item) => 
                            <Box key = {item?.file?.name} sx={{ display: 'flex', flexDirection: 'row'}}>
                                <Checkbox id={item?.file?.name} checked={checked[item?.file?.name] || false} onChange={e => handleCheck(e)}/>
                                <Box  sx={{ bgcolor: 'lightblue', color: 'black', p: 1, mb: 1, mt:1,textAlign: 'left' }}>
                                    {item?.file?.name}
                                </Box>
                                <Button 
                                    onClick={()=> handleDeleteForm(item?.file?.name)}
                                    sx={{ color: 'red' }}
                                >
                                    &#10005; 
                                </Button>
                            </Box>
                            )}
                    </Box>

                    <Box sx={{ display: 'flex', flexDirection: 'column',marginLeft : "5%",width:"60%"}}>
                        {Object.values(checked).filter((p)=> p===true).length === 1 ? <>
                            <FormControl>
                                <Select size="small" name="document" value={selectedDocument} onChange={handleDocumentSelect} fullWidth displayEmpty renderValue={selectedDocument !== "" ? undefined : () => "Select the Document"}>
                                
                                    {formList.length===0 ? <Typography color='red'>No documents available corresponding to the selected docket</Typography> :
                                        (formList.map((item) => (
                                            <MenuItem key={item.id} value={formMappings[item?.generated_form?.form_code]} size="small">
                                                        {formMappings[item?.generated_form?.form_code]}
                                            </MenuItem>
                                        )))
                                    }
                                </Select>
                            </FormControl>
                          

                            <Button variant="contained" color="primary" onClick={handleNewDocumentClick} sx={{mt:4}} >
                                    New Document
                                </Button>

                            <Box sx={{ display: 'flex', flexDirection: 'row', mt:1,mb:1}}>
                                
                                {newDocumentClick && <>
                                    <FormControl sx={{mr:1}} >
                                        <Select size="small" name="category" value={selectedCategory} onChange={handleSelectCategory} displayEmpty renderValue={selectedCategory !== "" ? undefined : () => "Select the Category"}>
                                        
                                            {/* {Object.keys(categoryMappings).map((item) => (
                                                    <MenuItem key={item} value={item} size="small">
                                                                {item}
                                                    </MenuItem>
                                                ))} */}
                                            
                                        </Select>
                                    </FormControl>

                                    <FormControl sx={{mr:1}} >
                                        <Select size="small" name="category" value={selectedDescription} onChange={(e)=> setSelectedDescription(e.target.value)} displayEmpty renderValue={selectedDescription !== "" ? undefined : () => "Select the Description"}>
                                        
                                            {/* {categoryMappings[selectedCategory]?.length > 0 ? (categoryMappings[selectedCategory]?.map((item) => (
                                                    <MenuItem key={item} value={item} size="small">{item}</MenuItem>
                                                ))) :
                                                <Typography color='red'>No category selected</Typography>
                                            } */}
                                            
                                        </Select>
                                    </FormControl>
                                    
                                    </>}

                            </Box>
                            {newDocumentClick && <TextField name="newDocumentName" value={newDocumentName} size="small" label="Enter Document Name" fullWidth={true} onChange={(e)=> setNewDocumentName(e.target.value)}></TextField>}
                            </> :
                      
                            <Typography color="red" align="center">Select any one file to perform further action</Typography>}
                        </Box> 
                
                </Box>

                <Box display="flex" justifyContent="space-between" sx={{ mt: 5}}>
                        <Box flexGrow={1} />
                        <Button variant="outlined" color="primary" onClick={handleCancel} sx={{ mr: 2}}>
                            Cancel
                        </Button>

                        <Button 
                            variant="contained" 
                            color="primary" 
                            sx={{ mr: 2}} 
                            disabled={!(selectedDocument!=="" || (selectedCategory!=="" && selectedDescription!=="" && newDocumentName!=""))}
                            onClick={handleSave} 
                        >
                            Save
                        </Button>
                    </Box>
                </DialogContent>
            </Dialog>
        </div> 

    );
};

export default UploadFormModal;